import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWordmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 161,
	height: 35,
	viewBox: "0 0 161 35",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#withco-wordmark-clip)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M159.377 1.62095V33.3813H1.62342V1.62095H159.379M161 0H0V35H161V0Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M34.7401 27.4473H26.7527L24.445 17.8154L22.1105 27.4473H14.4094L8.34058 7.56055H17.417L19.1276 16.6745L20.9947 7.56055H27.8931L29.9682 16.5718L31.8622 7.56055H40.7843L34.7423 27.4473H34.7401Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M42.2246 27.447V7.5625H51.1467V27.4493H42.2246V27.447Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M67.5238 13.4658V27.4493H58.6017V13.4658H53.0002V7.5625H73.1767V13.4658H67.5238Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M75.0327 7.5625H83.9548V14.2428H87.0675V7.5625H95.9895V27.4493H87.0675V19.8871H83.9548V27.4493H75.0327V7.5625Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M98.4917 27.447V19.8848H106.832V27.447H98.4917Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M129.097 20.2467C129.097 24.7301 125.199 27.8889 119.544 27.8889C112.488 27.8889 108.871 23.7621 108.845 17.954C108.82 11.2034 112.692 7.53516 119.57 7.53516C126.167 7.53516 128.562 11.127 128.562 14.1839C128.562 14.5405 128.537 14.8717 128.486 15.1519L121.124 15.9416C121.175 15.7633 121.2 15.3557 121.2 15.05C121.2 13.7508 120.741 12.8592 119.646 12.8592C118.372 12.8592 117.99 14.4896 117.99 17.6993C117.99 21.4695 118.449 22.3356 119.748 22.3356C121.149 22.3356 121.684 20.9345 121.684 19.0494C121.684 18.5654 121.633 18.1324 121.608 17.8521L128.791 18.2852C128.995 18.9985 129.097 19.4825 129.097 20.2467Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M129.991 17.8012C129.991 11.1779 134.143 7.53516 140.868 7.53516C147.593 7.53516 151.72 11.0251 151.72 17.8012C151.72 25.0868 146.905 27.8634 140.817 27.8634C135.238 27.8634 129.991 25.1887 129.991 17.8012ZM139.136 17.6738C139.136 21.5968 139.569 22.412 140.893 22.412C142.218 22.412 142.575 21.6223 142.575 17.6738C142.575 13.2923 141.836 12.8847 140.868 12.8847C139.874 12.8847 139.136 13.2923 139.136 17.6738Z" })
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "withco-wordmark-clip",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 161,
			height: 35
		})
	}) })]
});
export default SvgWordmark;
